<template>
  <v-dialog v-model="show" :max-width="maxWidth" @input="closeDialog" :persistent="loading">
    <v-card elevation="0" :loading="loading" :disabled="loading">
      <v-card-title>Selecione um atendimento anterior.</v-card-title>
      <v-card-subtitle
        >Para gerar um relatório comparativo, por favor selecione um dos atendimentos abaixo.</v-card-subtitle
      >
      <v-card-text>
        <v-fade-transition>
          <v-alert v-if="!!error" type="error" dismissible @input="clearError">{{ error }}</v-alert>
        </v-fade-transition>
        <crud-table
          ref="crudTable"
          :fetch-action="fetchAttendances"
          :can-create="true"
          :editable="false"
          :removable="false"
          :restorable="false"
          custom-only
          :min-search-length="0"
          :headers="headers"
          :custom-actions="customActions"
          @action:show-attendance-overview="openOverviewDialog"
          @click:row="$emit('selectAttendance', $event)"
        >
          <template #date="{ item }">
            <div class="d-flex flex-column justify-center">
              <label
                ><span class="text-caption font-weight-medium">Início:</span>
                {{ $moment(item.startedAt).format('DD/MM/YYYY HH:mm') }}</label
              >
              <label
                ><span class="text-caption font-weight-medium">Fim:</span>
                {{ item.endedAt ? $moment(item.endedAt).format('DD/MM/YYYY HH:mm') : '---' }}</label
              >
            </div>
            <attendance-overview-dialog ref="overviewDialog" />
          </template>
        </crud-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import CrudTable from '../CrudTable.vue'
import AttendanceOverviewDialog from '@/components/AttendanceForm/AttendanceOverviewDialog.vue'

export default {
  components: { CrudTable, AttendanceOverviewDialog },
  name: 'PreviousAttendanceDialog',
  props: {
    maxWidth: {
      type: [String, Number],
      default: '60vw',
    },
  },
  data() {
    return {
      show: false,
      error: '',
      loading: false,
      patientId: null,
      headers: [
        { text: 'Data', value: 'date', sortable: false },
        { text: 'Médico', value: 'physician.name', sortable: false },
      ],
      customActions: [
        {
          name: 'show-attendance-overview',
          icon: 'mdi-printer-eye',
          title: 'Visualizar resumo',
        },
      ],
      attendances: null,
    }
  },
  methods: {
    openDialog(patientId) {
      this.show = true
      this.patientId = patientId
    },
    closeDialog() {
      this.show = false
      this.patientId = null
      this.clearError()
    },
    clearError() {
      this.error = ''
    },

    async fetchAttendances() {
      try {
        const results = await this.$api.getPatientAttendances(this.patientId)
        results.items = results.items.filter(
          (attendance) => attendance.endedAt != null && attendance.disease.name === 'Psoríase',
        )
        this.attendances = results
        return this.attendances
      } catch (error) {
        this.$root.error(error)
      }
    },
    async openOverviewDialog(attendance) {
      this.$refs.overviewDialog.openDialog(attendance.id, this.attendances)
    },
  },
}
</script>

<style scoped></style>
